module.exports = {"TXTWCL_WEXLL_BE_BACK_SOONX":{"id":"TXTWCL_WEXLL_BE_BACK_SOONX","defaultMessage":"МЫ СКОРО ВОЗОБНОВИМ РАБОТУ!"}}